import { Render } from "../../../../../../../../homepage/Render";
import VideoDrmPlayer from "../../../../../../../features/video_feature/video_feature_content_component/VideoDrmPlayer";
import "./StoreOrientationVideo.scss";

export const StoreOrientationVideo = (props) => {
  const { packageData } = props;

  return (
    <Render if={!!packageData}>
      <div className="video-inner-wrapper">
        <div className="video-content-and-btn-wrapper">
          <h3>Orientation Video</h3>
        </div>
        <div style={{ width: "100%", height: "300px" }}>
          <VideoDrmPlayer id_video={packageData} />
        </div>
      </div>
    </Render>
  );
};
